import { renderRoutes } from 'react-router-config'
import { matchPath } from 'react-router'
import React, { useEffect, useMemo } from 'react'
import { useQuery } from 'react-query'
import { useTranslation } from 'react-i18next'
import { FacebookProvider } from 'react-facebook'
import emmit from '@/pages/sea/utils/emitter'
import { get } from '@/pages/sea/utils/fetch'
import { authToken } from '@/utils/helper'
import { isPC } from '@/utils'
import {
  useStoreReducer,
  StoreContext,
  storeActionType,
  // useMusicReducer,
  // MusicContext,
  // musicActionType,
} from '@/pages/sea/context'
import '@/pages/sea/static/lib/joymaker-jssdk.min'

// 无需PC和m跳转的白名单
const WHITE_LIST = [
  '/match-result',
  '/doram-kingdom-reserve',
  '/doram-kingdom-reserve-fb',
  '/ten-people-race',
  '/tenPeopleRace',
  '/activity/anniversary/:vroleid',
  '/For-Honor-reserve',
  '/reservation/sakura2024',
  '/discord/login-bind',
  '/valhalla/home',
  '/valhalla/news-detail',
]

/**
 * BaseLayout
 */
const BaseLayout = (props: React.PropsWithChildren<any>) => {
  const { route, children } = props
  const [store, dispatch] = useStoreReducer()
  const { t } = useTranslation()
  // const [musicStore, musicDispatch] = useMusicReducer()
  // const { initTa } = useTA()

  // useEffect(() => {
  //   initTa?.()
  // }, [initTa])

  // const stopMusic = useCallback(() => {
  //   musicDispatch({
  //     type: musicActionType.MUSIC_STATUS,
  //     data: false,
  //   })
  // }, [musicDispatch])

  const storeCtxValue = useMemo(() => ({ store, dispatch }), [dispatch, store])
  // const musicCtxValue = useMemo(
  //   () => ({ ...musicStore, stopMusic, musicDispatch }),
  //   [musicDispatch, musicStore, stopMusic]
  // )

  const { refetch: getJobIntro } = useQuery<
    unknown,
    ReturnData | Error,
    ReturnData
  >('/sea/api/job-intro', async () => get('/api/job-intro'), {
    refetchOnWindowFocus: false,
    retry: false,
    onSuccess: (res) => {
      dispatch({
        type: storeActionType.UPDATE_HOMEDATA,
        data: res?.data,
      })
    },
  })

  const getData = (res: any) => [
    {
      id: 0,
      name: t('sea.recent'),
      weight: 0,
    },
    ...((res?.data?.news_categories as any[]) ?? []),
  ]

  const { refetch: getNewsCategories } = useQuery<
    unknown,
    ReturnData | Error,
    ReturnData
  >('/sea/api/news-categories', async () => get('/api/news-categories'), {
    refetchOnWindowFocus: false,
    retry: false,
    onSuccess: (res) => {
      dispatch({
        type: storeActionType.UPDATE_NEWS_CATEGORIES,
        data: getData(res),
      })
    },
  })

  useEffect(() => {
    emmit.on('getJobIntro', () => {
      getJobIntro()
    })
    return () => {
      emmit.off('getJobIntro', () => {
        getJobIntro()
      })
    }
  }, [getJobIntro])

  useEffect(() => {
    emmit.on('getNewsCategories', () => {
      getNewsCategories()
    })
    return () => {
      emmit.off('getNewsCategories', () => {
        getNewsCategories()
      })
    }
  }, [getNewsCategories])

  useEffect(() => {
    if (authToken()) {
      dispatch({
        type: storeActionType.LOGIN_STATUS,
        data: true,
      })
    }
  }, [dispatch])

  useEffect(() => {
    const { pathname, search } = window.location
    console.log(pathname, matchPath(pathname, '/activity/anniversary/:vroleid'))
    if (!WHITE_LIST.some((routeStr) => matchPath(pathname, routeStr))) {
      const path = pathname.slice(1).split('/') || []
      if (isPC()) {
        if (path[0] === 'm') {
          window.location.replace(`/${path.slice(1).join('/')}${search}`)
        }
      } else if (path[0] !== 'm') {
        window.location.replace(`/m${pathname}${search}`)
      }
    }
  }, [])

  const lang = localStorage.getItem('i18nextLng') || 'en'
  return (
    <div className="layout-container">
      <FacebookProvider appId="873582734092462" language={lang}>
        <StoreContext.Provider value={storeCtxValue}>
          {/* <MusicContext.Provider value={musicCtxValue}> */}
          {renderRoutes(route.routes)}
          {children}
          {/* </MusicContext.Provider> */}
        </StoreContext.Provider>
      </FacebookProvider>
    </div>
  )
}

export default React.memo(BaseLayout)
